@import "../shared.css";

:host {
	display: flex;
	position: relative;
	background-color: rgb(var(--smoothly-input-background));
	align-items: center;
	justify-content: center;
}
:host>smoothly-input {
	width: 100%;
	--input-min-height: calc(var(--input-min-height) - 2px);
	--smoothly-input-border-focus: none;
}
:host div.color-sample {
	height: 2em;
	width: 3em;
	margin-right: 0.5rem;
	background-color: var(--hexCode);
	outline: 1px solid rgb(var(--smoothly-input-border));
	border-radius: 3px;
}
:host smoothly-icon[name=options-outline] {
	padding-right: var(--input-padding-side);
}
:host[readonly] smoothly-icon[name=options-outline],
:host[disabled] smoothly-icon[name=options-outline] {
	display: none;
}
:host:not([readonly]):not([disabled]) smoothly-icon[name=options-outline] {
	cursor: pointer;
}
:host>div.rgb-sliders {
	background-color: rgb(var(--smoothly-input-background));
	position: absolute;
	padding: 1em 1em 1em 0;
	top: calc(var(--element-height) + .8em);
	left: 0;
	box-sizing: border-box;
	z-index: 20;
	border: 1px solid rgb(var(--smoothly-input-border));
}
:host>div.rgb-sliders::before {
	content: "";
	transform: translate(2em, -0.55em) rotate(45deg);
	width: 1em;
	height: 1em;
	background-color: rgb(var(--smoothly-input-background));
	border-top: 1px solid rgb(var(--smoothly-input-border));
	border-left: 1px solid rgb(var(--smoothly-input-border));
	position: absolute;
	z-index: 100;
	top: 0em
}
:host>div.rgb-sliders>smoothly-toggle-switch {
	margin-left: auto;
	margin-right: 1em;
	margin-bottom: 1em;
}
div.rgb-sliders smoothly-input-range {
	padding: .5em 0
}
div.rgb-sliders smoothly-input-range label {
	width: 4em;
}

/* -------------RGB SLIDERS------------------- */

/* --------------------R------------------- */
div.rgb-sliders smoothly-input-range>div>input[name=r]::-webkit-slider-runnable-track {
	background: linear-gradient(to left, rgb(255, var(--rgb-g), var(--rgb-b)), rgb(0, var(--rgb-g), var(--rgb-b)))
}
div.rgb-sliders smoothly-input-range>div>input[name=r]::-moz-range-track {
	background: linear-gradient(to left, rgb(255, var(--rgb-g), var(--rgb-b)), rgb(0, var(--rgb-g), var(--rgb-b)))
}
div.rgb-sliders smoothly-input-range>div>input[name=r]::-moz-range-thumb {
	background-color: red;
}
div.rgb-sliders smoothly-input-range>div>input[name=r]::-webkit-slider-thumb {
	background-color: red;
}

/* --------------------G------------------- */
div.rgb-sliders smoothly-input-range>div>input[name=g]::-webkit-slider-runnable-track {
	background: linear-gradient(to left, rgb(var(--rgb-r), 255, var(--rgb-b)), rgb(var(--rgb-r), 0, var(--rgb-b)))
}
div.rgb-sliders smoothly-input-range>div>input[name=g]::-moz-range-track {
	background: linear-gradient(to left, rgb(var(--rgb-r), 255, var(--rgb-b)), rgb(var(--rgb-r), 0, var(--rgb-b)))
}
div.rgb-sliders smoothly-input-range>div>input[name=g]::-moz-range-thumb {
	background-color: green;
}
div.rgb-sliders smoothly-input-range>div>input[name=g]::-webkit-slider-thumb {
	background-color: green;
}

/* --------------------B------------------- */
div.rgb-sliders smoothly-input-range>div>input[name=b]::-webkit-slider-runnable-track {
	background: linear-gradient(to left, rgb(var(--rgb-r), var(--rgb-g), 255), rgb(var(--rgb-r), var(--rgb-g), 0))
}
div.rgb-sliders smoothly-input-range>div>input[name=b]::-moz-range-track {
	background: linear-gradient(to left, rgb(var(--rgb-r), var(--rgb-g), 255), rgb(var(--rgb-r), var(--rgb-g), 0))
}
div.rgb-sliders smoothly-input-range>div>input[name=b]::-moz-range-thumb { 
	background-color: blue;
}
div.rgb-sliders smoothly-input-range>div>input[name=b]::-webkit-slider-thumb  {
	background-color: blue;
}

/* -------------HSL SLIDERS------------------- */

/* --------------------H------------------- */
div.rgb-sliders smoothly-input-range>div>input[name=h]::-webkit-slider-runnable-track {
	background: linear-gradient(to right in hsl longer hue, red, red)
}
div.rgb-sliders smoothly-input-range>div>input[name=h]::-moz-range-track {
	background: linear-gradient(to right in hsl longer hue, red, red)
}
div.rgb-sliders smoothly-input-range>div>input[name=h]::-webkit-slider-thumb {
	background-color: hsl(var(--hsl-h), 100%, 50%)
}
div.rgb-sliders smoothly-input-range>div>input[name=h]::-moz-range-thumb {
	background-color: hsl(var(--hsl-h), 100%, 50%)
}


/* --------------------S------------------- */
div.rgb-sliders smoothly-input-range>div>input[name=s]::-webkit-slider-runnable-track { 
	background: linear-gradient(to right, hsl(var(--hsl-h), 0%, 50%), hsl(var(--hsl-h), 100%, 50%)); 
}
div.rgb-sliders smoothly-input-range>div>input[name=s]::-moz-range-track {
	background: linear-gradient(to right, hsl(var(--hsl-h), 0%, 50%), hsl(var(--hsl-h), 100%, 50%)); 
}
div.rgb-sliders smoothly-input-range>div>input[name=s]::-moz-range-thumb {
	background-color: hsl(var(--hsl-h), var(--hsl-s), 50%)
}
div.rgb-sliders smoothly-input-range>div>input[name=s]::-webkit-slider-thumb {
	background-color: hsl(var(--hsl-h), var(--hsl-s), 50%)
}

/* --------------------L------------------- */
div.rgb-sliders smoothly-input-range>div>input[name=l]::-moz-range-track {
	background: linear-gradient(to right, black, white)
}
div.rgb-sliders smoothly-input-range>div>input[name=l]::-webkit-slider-runnable-track {
	background: linear-gradient(to right, black, white)
}
div.rgb-sliders smoothly-input-range>div>input[name=l]::-moz-range-thumb {
	background-color: #777;
}
div.rgb-sliders smoothly-input-range>div>input[name=l]::-webkit-slider-thumb {
	background-color: #777;
}
